import React from "react";
import "./Keynotes.css";

export const Panel = () => {
  return (
    <div className="keynote-layout">
      <div className="keynote-text-layout">
        <h2>Panel</h2>
        <h3>
          Thursday 19th June 2025, Room G03, Western Gateway Building, UCC
        </h3>
        <h3>Topic: Digitalisation of Healthcare</h3>
        <h4 style={{ marginBottom: "0px" }}>Moderator: </h4>
        <h5 style={{ marginTop: "0px" }}>Nick Pham, Cardiff University, UK</h5>
        <h4 style={{ marginBottom: "0px" }}>Panelists:</h4>
        <h5 style={{ marginTop: "0px", marginBottom: "0px" }}>
          Giancarlo Fortino, University of Calabria, Italy
        </h5>
        <h5 style={{ marginTop: "0px", marginBottom: "0px" }}>
          Richard Greene, University College Cork, Ireland
        </h5>
        <h5 style={{ marginTop: "0px", marginBottom: "0px" }}>
          Mark O'Sullivan, NeuroBell
        </h5>
        <h5 style={{ marginTop: "0px", marginBottom: "0px" }}>
          Akane Sano, Rice University, USA
        </h5>
        <br />
        <hr />
        <div className="keynote-biography-layout">
          <img className="keynote-img" src={"./images/profiles/nickpham.png"} />
          <div className="keynote-text">
            <h3>Dr Nick Pham</h3>
            <p>
              Dr Nhat (Nick) Pham leads the Adaptive and Intelligent
              Cyber-Physical Systems (AGILE) lab at the School of Computer
              Science and Informatics, Cardiff University, UK. His research
              interests include Intelligent and Efficient Cyber-Physical
              Systems, Human-based Sensing, and On-chip Intelligence.
            </p>
            <p>
              Before joining Cardiff University, he obtained my DPhil (PhD) with
              his research on intelligent head-worn physiological sensing
              wearables, funded by the University of Oxford DPhil Scholarship.
              He also worked as a postdoctoral researcher on the EPSRC ACE-OPS
              project at Oxford University from 2022 to 2023.
            </p>{" "}
            <p>
              His research has been recognised by a Google Research Scholar
              Award'25, SIU Prize for Best Vietnamese PhD Dissertations'24,
              Oxford University's nominee for ACM SIGMOBILE Dissertation
              Award'24, Communication of the ACM Research Highlight'21, ACM
              SIGMOBILE Research Highlight'20, ACM GetMobile'19 Research
              Highlight, and the Best Paper at ACM MobiCom'19. He helped to spin
              off a tech startup (Earable Neuroscience Inc.) and produced
              multiple international patents. His group’s work has been featured
              in several press articles from Bloomberg, BBC News, Daily Mail,
              Euronews, etc. He is leading several funded projects from EPSRC,
              the Royal Society, Global Wales, the Academy of Medical Science,
              and the Alan Turing Institute.
            </p>
          </div>
        </div>
        <hr />

        <div className="keynote-biography-layout">
          <img
            className="keynote-img"
            src={"./images/profiles/giancarlo.png"}
          />
          <div className="keynote-text">
            <h3>Professor Giancarlo Fortino</h3>
            <p>
              Giancarlo Fortino (IEEE Fellow 2022) is Full Professor of Computer
              Engineering at the Dept of Informatics, Modeling, Electronics, and
              Systems of the University of Calabria (Unical), Italy. He received
              a PhD in Computer Engineering from Unical in 2000. He is also
              distinguished professor at Wuhan University of Technology (China),
              high-end expert at Huazhong University of Science and Technology
              (China), senior research fellow at the Italian ICAR-CNR Institute,
              CAS PIFI Group international fellow at SIAT (Shenzhen), and
              Distinguished Lecturer for IEEE Sensors Council, SMC society, and
              IoT TC.
            </p>
            <p>
              He was also visiting researcher at ICSI, Berkeley (USA), in 1997
              and 1999 and visiting professor at Queensland University of
              technology in 2009. At Unical, he is the Rector’s delegate to
              Int’l relations, the chair of the PhD School in ICT, the director
              of the Postgraduate Master course in AI-driven Radiomics, and the
              director of the SPEME lab as well as co-chair of Joint labs on IoT
              established between Unical and WUT, SMU and HZAU Chinese
              universities, respectively. Fortino is currently the scientific
              responsible of the Digital Health group of the Italian CINI
              National Laboratory at Unical.
            </p>
            <p>
              He is Highly Cited Researcher 2020-2024 in Computer Science by
              Clarivate (the only Italian professor ranked). He had 25+ highly
              cited papers in WoS, and h-index=86 with 30000+ citations in
              Google Scholar.{" "}
            </p>
            <p>
              His research interests include wearable computing systems,
              e-Health, Internet of Things, and agent-based computing. He is
              author of 750+ papers in int’l journals, conferences and books. He
              is (founding) series editor of IEEE Press Book Series on
              Human-Machine Systems and EiC of Springer Internet of Things
              series and AE of premier int'l journals such as IEEE TASE (senior
              editor), IEEE TAFFC-CS, IEEE THMS, IEEE T-AI, IEEE SJ, IEEE JBHI,
              IEEE OJEMB, IEEE OJCS, Information Fusion, EAAI, etc. He chaired
              many int’l workshops and conferences (130+), was involved in a
              huge number of int’l conferences/workshops (700+) as IPC member,
              is/was guest-editor of many special issues (80+). He is cofounder
              and CEO of SenSysCal S.r.l., a Unical spinoff focused on
              innovative IoT systems, and recently cofounder and vice-CEO of the
              spin-off Bigtech S.r.l, focused on big data, AI and IoT
              technologies. Fortino is currently AVP of the Cybernetics area of
              the IEEE SMCS and former member of the IEEE SMCS BoG and former
              chair of the IEEE SMCS Italian Chapter.
            </p>
          </div>
        </div>
        <hr />

        <div className="keynote-biography-layout">
          <img className="keynote-img" src={"./images/profiles/richardg.png"} />
          <div className="keynote-text">
            <h3>Professor Richard Greene</h3>
            <p>
              Professor Richard Greene, a graduate of Trinity College Dublin,
              gained much of his clinical experience in the Coombe Womens'
              Hospital, Dublin. In July 1999, he took up a position as Fellow in
              Maternal-Fetal Medicine in Thomas Jefferson University Hospital,
              Philadelphia, USA. On his return to Ireland in 2001, he joined UCC
              as Senior Lecturer/Consultant in Obstetrics and Gynaecology: and
              took up his current posts as Director of the National Perinatal
              Epidemiology Centre (NPEC) and Professor of Clinical Obstetrics,
              UCC, in 2007.
            </p>{" "}
            <p>
              {" "}
              Prof. Greene was instrumental in commissioning and establishing
              the new maternity services at CUMH and continues to maintain a
              senior management position within the service. His research
              interests include maternal-fetal medicine, epidemiology, health
              services research incorporating risk management, quality of
              service and translational research.
            </p>{" "}
            <p>
              The NPEC under the guidance and leadership of Prof Greene continue
              to aim for improved clinical services for Irish patients.
            </p>
          </div>
        </div>
        <hr />

        <div className="keynote-biography-layout">
          <img className="keynote-img" src={"./images/profiles/markos.png"} />
          <div className="keynote-text">
            <h3>Dr Mark O'Sullivan</h3>
            <p>
              Mark O’Sulivan, PhD is the CEO & Co-Founder of NeuroBell, a
              medical device company developing novel products for early
              detection and monitoring of seizures in newborns
            </p>
            <p>
              Mark originally completed his PhD and Postdoctoral Research in
              Electronic Engineering at the INFANT Research Centre, University
              College Cork (UCC) developing clinical decision support systems
              for monitoring fetal and neonatal health. Mark subsequently
              secured €600,000 in Enterprise Ireland Commercialisation Grant
              Funding for the NeuroBell project, which he led as Principal
              Investigator, before successfully spinning out NeuroBell with
              co-founders Alison O’Shea and Colm Murphy.
            </p>
            <p>
              NeuroBell has raised €2.1 million private funding, led by Furthr
              VC, Atlantic Bridge, and HBAN Medtech Syndicate, and employees 15
              staff at their Cork office. NeuroBell Luna is the company’s first
              product, which has undergone a clinical trial in Cork University
              Maternity Hospital (CUMH), Ireland, and is currently beginning
              clinical trials in the US.
            </p>
          </div>
        </div>
        <hr />
        <div className="keynote-biography-layout">
          <img
            className="keynote-img"
            src={"./images/profiles/Akane_Sano.webp"}
          />
          <div className="keynote-text">
            <h3>Professor Akane Sano</h3>
            <p>
              Akane Sano is an Assistant Professor at Rice University,
              Department of Electrical Computer Engineering, Computer Science,
              and Bioengineering. She directs the Computational Wellbeing Group
              and is a member of Scalable Health Labs.
            </p>
            <p>
              Her research includes data science, machine learning, and
              human-centered intelligent systems for health and wellbeing and
              spans in the field of affective computing, ubiquitous and wearable
              computing, and biobehavioral sensing and analysis/modeling. Her
              research targets (1) the analysis and modeling of human ambulatory
              multimodal time series data including physiological, biological
              and behavioral data and surveys for measuring, predicting,
              improving, and understanding human physiology and behavior and
              human factors such as health, wellbeing, and performance and (2)
              development of human-centered computing technologies for health,
              wellbeing, and performance. She has been working on developing
              tools, algorithms, and systems to measure, forecast, understand
              and improve health and wellbeing using multimodal data from mobile
              and wearable sensors, devices in daily life settings, and clinical
              assessment especially for measuring, predicting, and
              intervening/improving clinical outcomes, stress, mental health,
              sleep, and performance.{" "}
            </p>
            <p>
              She obtained her PhD at MIT Media Lab, and her MEng and BEng at
              Keio University, Japan. Before she joined Rice University, she was
              a Research Scientist in Affective Computing Group at MIT Media
              Lab, and a visiting scientist/lecturer at People-Aware Computing
              Lab, Cornell University. Before she came to the US, she was a
              researcher/engineer at Sony Corporation focusing on wearable
              computing, intelligent systems, and human/computer interaction.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
